import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import format from 'date-fns/format';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import 'Components/Blog/cards/BlogPostsList.scss';

import store from 'Redux/store';

const onLinkClick = (link) => {
  store.dispatch({
    type: 'frontend/click/CLICK_INTERACTION',
    payload: { section: 'ProductPageBlogSection', value: link },
  });
};


export default function BlogPostsList({ post }) {
  if (isEmpty(post)) return false;
  const title = get(post, 'data.title[0].text', '');
  const image = get(post, 'data.cover.224x126', '');
  return (
    <Link className="faux-block-link__overlay-link blog-posts-list-container" to={{ pathname: `/blog/${post.uid}` }} onClick={() => onLinkClick(`/blog/${post.uid}`)}>
      <article className="blog-posts-list">
        <div className="responsive-image-island blog-list-img mr-3">
          <div className="responsive-image responsive-image--16by9">
            <img
              className="img-fluid"
              src={image.url}
              alt={title}
              loading="lazy"
            />
          </div>
        </div>
        <div className="media-body">
          <h3 className="blog-list-title">
            {title}
          </h3>
          <p className="blog-meta">
            {format(post.data.publication_datetime, 'Do MMMM')}
          </p>
        </div>
      </article>
    </Link>
  );
}

BlogPostsList.propTypes = {
  post: PropTypes.shape({}),
};

BlogPostsList.defaultProps = {
  post: {},
};
